import { motion } from "framer-motion";

export default function ProjectCard({ title, category, description, onClick }) {
  return (
    <motion.article
      className="cardStyle"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <p className="text-sm text-gray-500 mb-2">{category}</p>
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <p className="cardText mb-4">{description}</p>
      <button className="project-btn" onClick={onClick}>
        View Project
      </button>
    </motion.article>
  );
}
